export * from "./ast.js";
export * from "./schema.js";
export { emptySchemaData, indexSchema } from "./schema-data.js";
export { lex, LexError } from "./lexer.js";
export { parse, print, ParseError } from "./parser.js";
export { resolve, ResolveError } from "./resolve.js";
export { compilePredicate, compileComparator } from "./compile-predicate.js";
export { compileSql } from "./compile-sql.js";
import { parse } from "./parser.js";
import { resolve } from "./resolve.js";
/** parse + resolve in one step. */
export function compileQuery(input, schema) {
    return resolve(parse(input), schema);
}
//# sourceMappingURL=index.js.map